export default "__VITE_ASSET__96d377a4__"